import { render } from "./Access.vue?vue&type=template&id=93b47a46"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/momentum-generator/momentum-generator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__